var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.21355 2.10413C5.93816 2.44967 5 3.61527 5 4.99999V19C5 20.6569 6.34315 22 8 22H16C17.6569 22 19 20.6569 19 19V4.99999C19 3.61527 18.0618 2.44967 16.7865 2.10413L16.2236 3.22983C15.7578 4.16148 14.8056 4.74999 13.7639 4.74999H10.2361C9.19444 4.74999 8.24222 4.16148 7.77639 3.22983L7.21355 2.10413ZM8.25 19C8.25 18.5858 8.58579 18.25 9 18.25H15C15.4142 18.25 15.75 18.5858 15.75 19C15.75 19.4142 15.4142 19.75 15 19.75H9C8.58579 19.75 8.25 19.4142 8.25 19Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1615 2H8.8385L9.118 2.55902C9.32974 2.9825 9.76257 3.25 10.2361 3.25H13.7639C14.2374 3.25 14.6702 2.9825 14.882 2.55902L15.1615 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAlt);
export default __webpack_public_path__ + "static/media/mobile-alt.4fb6c102e55870d4dc76662e873092ce.svg";
export { ForwardRef as ReactComponent };